/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { evaluateDependencies } from './dependenciesEvaluate.generated.js';
import { createParserClass } from '../../factoriesAny.js';
export var ParserDependencies = {
  evaluateDependencies,
  createParserClass
};